export default __webpack_public_path__ + "static/media/5_bottom.d1610133.jpg";